import { render, staticRenderFns } from "./proxyBalanceWithdrawList.vue?vue&type=template&id=35bd91d4&scoped=true"
import script from "./proxyBalanceWithdrawList.vue?vue&type=script&lang=js"
export * from "./proxyBalanceWithdrawList.vue?vue&type=script&lang=js"
import style0 from "./proxyBalanceWithdrawList.vue?vue&type=style&index=0&id=35bd91d4&prod&scoped=true&lang=css"
import style1 from "./proxyBalanceWithdrawList.vue?vue&type=style&index=1&id=35bd91d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd91d4",
  null
  
)

export default component.exports